module.exports = __webpack_public_path__ + "static/media/6.8_preview.b0b84238.png";